export default __webpack_public_path__ + "static/media/ALLERGIES.18d857f8.png";